import type { VehicleTestImages } from "@/types/vehicleTest";
import { isVideoMedia } from "@/lib/isVideoMedia";

export interface ImageValidationLabels {
  exteriorRequired: string;
  thumbnailRequired: string;
  otherExteriorRequired: string;
  interiorRequired: string;
}

/** Exterior photos only — engine video does not count. */
export function hasExteriorPhoto(currentImages: VehicleTestImages): boolean {
  return !!currentImages.exterior?.some(
    (img) => img.url && !isVideoMedia(img.type, img.url),
  );
}

export const isSectionValid = (currentImages: VehicleTestImages): boolean => {
  const hasInterior = currentImages.interior?.some((img) => img.url);

  return !!(hasExteriorPhoto(currentImages) && hasInterior);
};

export const getValidationErrors = (
  currentImages: VehicleTestImages,
  labels: ImageValidationLabels,
): string[] => {
  const errors: string[] = [];

  if (!hasExteriorPhoto(currentImages)) {
    errors.push(labels.exteriorRequired);
  }

  if (!currentImages.interior?.some((img) => img.url)) {
    errors.push(labels.interiorRequired);
  }

  return errors;
};
